<template>
  <div class="about">
    <h1>Event List</h1>
  </div>
</template>
